import { UpdateTemporaryPasswordMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const updateTemporaryPasswordHandler =
  graphql.mutation<UpdateTemporaryPasswordMutation>(
    "updateTemporaryPassword",
    async ({ query, variables }) => {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      return HttpResponse.json(
        {
          data: {
            updateTemporaryPassword: {
              result: true,
            },
          },
        }
        // // Error (uncomment if you want to test error handling)
        // ctx.data({
        //   updateTemporaryPassword: {
        //     result: false,
        //   },
        // }),
        // ctx.errors([
        //   {
        //     extensions: {
        //       code: ErrorCode[ErrorCode.INTERNAL_SERVER_ERROR],
        //     },
        //   },
        // ])
      );
    }
  );
